module.exports = {
    expressPort: 8000,
    // siteUrl: (window.location.hostname == "admin.theelderlywellness.com") ? 'https://elderly-admin-service.theelderlywellness.com/api' : 'https://elderly-admin-service.codiflysoftware.com/api'
    siteUrl: (window.location.hostname == "admin.theelderlywellness.com") ? 'https://elderly-admin-service.theelderlywellness.com/api' : 'https://elderly-admin-service-staging.theelderlywellness.com/api',
    walletService: (window.location.hostname == "admin.theelderlywellness.com") ? 'https://elderly-wallet-service.theelderlywellness.com/api' : 'https://elderly-wallet-service-staging.theelderlywellness.com/api',

    // siteUrl: 'http://localhost:8000/api'
};
